"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BinaryOperation = void 0;
const expression_node_1 = require("./expression-node");
class BinaryOperation extends expression_node_1.ExpressionNode {
    constructor(leftOperand, rightOperand) {
        super();
        this.leftOperand = leftOperand;
        this.rightOperand = rightOperand;
    }
    get children() {
        return [this.leftOperand, this.rightOperand];
    }
    format() {
        return `${this.formatSubExpression(this.leftOperand)} ${this.formattedOperator} ${this.formatSubExpression(this.rightOperand)}`;
    }
}
exports.BinaryOperation = BinaryOperation;
//# sourceMappingURL=binary-operation.js.map